import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { BrandPage } from './pages/BrandPage';
import { VisualLanguage } from './pages/VisualLanguage';
import { LogoPage } from './pages/LogoPage';
import { ColoursPage } from './pages/ColoursPage';
import { TypographyPage } from './pages/TypographyPage';
import { BrandVoice } from './pages/BrandVoice';
import { ProposalPage } from './pages/ProposalPage';
import { FinalAssets } from './pages/FinalAssets';
import { ChecklistPage } from './pages/ChecklistPage';
import { Toaster } from 'sonner';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Toaster position="top-center" richColors data-id="element-1" />
      <div className="w-full min-h-screen" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<BrandPage data-id="element-5" />} data-id="element-4" />
          <Route path="/logo" element={<LogoPage data-id="element-7" />} data-id="element-6" />
          <Route path="/typography" element={<TypographyPage data-id="element-9" />} data-id="element-8" />
          <Route path="/colours" element={<ColoursPage data-id="element-11" />} data-id="element-10" />
          <Route path="/brandvoice" element={<BrandVoice data-id="element-13" />} data-id="element-12" />
          <Route path="/visuallanguage" element={<VisualLanguage data-id="element-15" />} data-id="element-14" />
          <Route path="/proposal" element={<ProposalPage data-id="element-17" />} data-id="element-16" />
          <Route path="/project-plan" element={<ChecklistPage data-id="element-19" />} data-id="element-18" />
          <Route path="/checklist" element={<Navigate to="/project-plan" replace data-id="element-21" />} data-id="element-20" />
          <Route path="/final-assets" element={<FinalAssets data-id="element-23" />} data-id="element-22" />
        </Routes>
      </div>
    </BrowserRouter>;
}